import { useClientTranslation } from '@bts-web/utils-lokalise';
import { TradePriceType, OrderOperation } from '../../types';
import { iconContainerStyles } from '../OrderTypeDrawer/OrderTypeDrawer';
import { RegularMarketOrder, RegularStopOrder } from '../../../common/svgIcons';
import { Drawer } from '../../../common/components/Drawer';
import {
  ListCellsSelectionCheckmarkItem,
  ListCellsSelectionRoot,
} from '../../../common/components/ListCellsSelection';

interface PriceTypeDrawerProps {
  selectedOrderOperation: OrderOperation;
  priceType: TradePriceType;
  title?: string;
  onChangeTradeType: (value: TradePriceType) => void;
}

const PriceTypeDrawer = ({
  selectedOrderOperation,
  priceType,
  title,
  onChangeTradeType,
}: PriceTypeDrawerProps) => {
  const { t } = useClientTranslation();

  const marketLabel =
    selectedOrderOperation === OrderOperation.SELL ? t('sell') : t('buy');

  const stopLabel =
    selectedOrderOperation === OrderOperation.SELL
      ? t('stop_order_sell_title')
      : t('stop_order_buy_title');

  const marketSubLabel =
    selectedOrderOperation === OrderOperation.SELL
      ? t('stop_order_instant_sell')
      : t('stop_order_instant_buy');

  const stopSubLabel =
    selectedOrderOperation === OrderOperation.SELL
      ? t('stop_order_sell_subtitle')
      : t('stop_order_buy_subtitle');

  return (
    <Drawer title={title as string}>
      <ListCellsSelectionRoot
        value={priceType}
        onValueChange={onChangeTradeType}
      >
        <ListCellsSelectionCheckmarkItem
          key={TradePriceType.MARKET}
          id={TradePriceType.MARKET}
          value={TradePriceType.MARKET}
          activeItemId={priceType}
          label={marketLabel}
          subLabel={marketSubLabel}
          icon={
            <div className={iconContainerStyles}>
              <RegularMarketOrder />
            </div>
          }
        />
        <ListCellsSelectionCheckmarkItem
          key={TradePriceType.STOP}
          id={TradePriceType.STOP}
          value={TradePriceType.STOP}
          activeItemId={priceType}
          label={stopLabel}
          subLabel={stopSubLabel}
          icon={
            <div className={iconContainerStyles}>
              <RegularStopOrder />
            </div>
          }
        />
      </ListCellsSelectionRoot>
    </Drawer>
  );
};

export { PriceTypeDrawer };
